import { render, staticRenderFns } from "./courseRank.vue?vue&type=template&id=04d80cd3&scoped=true"
import script from "./courseRank.vue?vue&type=script&lang=js"
export * from "./courseRank.vue?vue&type=script&lang=js"
import style0 from "./courseRank.vue?vue&type=style&index=0&id=04d80cd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d80cd3",
  null
  
)

export default component.exports